import styled from 'styled-components';

export const SectionBase = styled.div`
	flex-grow: 1;
	padding: 20px;
	background-color: ${({ theme }) => theme.gray[0]};
	color: ${({ theme }) => theme.gray[1000]};
	overflow-y: auto;
`;

export const SectionHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
	gap: 20px;
`;

export const SectionTitle = styled.h2`
	font-size: 24px;
	font-weight: 600;
	margin: 0;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const SectionContent = styled.div`
	font-size: 16px;
	line-height: 1.5;
	color: ${({ theme }) => theme.gray[800]};

	p {
		margin-bottom: 10px;
	}
`;
